import { FormLabel, TextareaAutosize, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useFormError } from "./FormErrorProvider";
import React, { useState } from "react";

export default function TextareaAutosizeElement({
  validation = {},
  parseError,
  required,
  name,
  control,
  rows,
  resizeStyle,
  label,
  staticLabel,
  afterLabel,
  ...rest
}) {
  const [shrinkLabel, setShrinkLabel] = useState();
  const errorMsgFn = useFormError();
  const customErrorFn = parseError || errorMsgFn;
  if (required && !validation.required) {
    validation.required = "This field is required";
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      render={({
        field: { value, onChange, onBlur, ref },
        fieldState: { error },
      }) => (
        <>
          {staticLabel && (
            <FormLabel
              required={required}
              error={!!error}
              htmlFor={rest.id}
              id={`${rest.id}.label`}
              sx={{ display: "flex", ...rest?.InputLabelProps?.sx }}
            >
              {label}
            </FormLabel>
          )}
          {afterLabel}
          <TextField
            {...rest}
            name={name}
            value={value ?? ""}
            label={!staticLabel ? label : undefined}
            onChange={(ev) => {
              if (document.activeElement !== ev.target) {
                // Only shrink label if the input is unfocused
                setShrinkLabel(!!ev.target.value); // Shrink label if value exists
              }
              onChange(ev.target.value);
              if (typeof rest.onChange === "function") {
                rest.onChange(ev);
              }
            }}
            onBlur={(e) => {
              setShrinkLabel(!!e.target.value); // Shrink only if value exists on blur
              onBlur(e);
              if (rest?.onBlur) {
                rest.onBlur(e);
              }
            }}
            onFocus={(e) => {
              setShrinkLabel(true); // Shrink on focus
              if (rest?.onFocus) {
                rest.onFocus(e);
              }
            }} // }}
            required={required}
            error={!!error}
            helperText={
              error
                ? typeof customErrorFn === "function"
                  ? customErrorFn(error)
                  : error.message
                : rest.helperText
            }
            inputRef={ref}
            multiline
            InputLabelProps={{
              shrink: shrinkLabel,
              onMouseDown: (e) => {
                e.preventDefault();
                e.stopPropagation();
              },
              ...rest?.InputLabelProps,
            }}
            InputProps={{
              inputComponent: TextareaAutosize,
              inputProps: {
                minRows: rows,
                style: {
                  resize: resizeStyle || "both",
                },
              },
              ...rest?.InputProps,
            }}
            sx={{
              ...rest?.sx,
              "& .MuiFormLabel-root": {
                display: "flex",
                zIndex: 1,
              },
            }}
          />
        </>
      )}
    />
  );
}
